import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ClientReportService {
  private apiUrl = '/clientreports';
  private apiSprUrl = '/spring/clientreports';

  constructor(private http: HttpService) { }

  post(
    ownerId: number,
    reportCd: string,
    printagentCd: string,
    updprogramCd: string,
    selectIds?: object[]
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSprUrl}`;
    let jsonInput = {};
    if (selectIds === undefined) {
      jsonInput = {
        ownerId: ownerId,
        reportCd: reportCd,
        printagentCd: printagentCd,
        updprogramCd: updprogramCd,
      };
    } else {
      jsonInput = {
        ownerId: ownerId,
        reportCd: reportCd,
        printagentCd: printagentCd,
        updprogramCd: updprogramCd,
        selectIds: selectIds
      };
    }
    return this.http.post(url, jsonInput);
  }

  post2(
    ownerId: number,
    reportCd: string,
    printagentCd: string,
    printnumNr: number,
    parameter1Tx: string,
    updprogramCd: string,
    selectIds?: object[]
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSprUrl}`;
    let jsonInput = {};
    if (selectIds === undefined) {
      jsonInput = {
        ownerId: ownerId,
        reportCd: reportCd,
        printagentCd: printagentCd,
        printnumNr: printnumNr,
        parameter1Tx: parameter1Tx,
        updprogramCd: updprogramCd,
      };
    } else {
      jsonInput = {
        ownerId: ownerId,
        reportCd: reportCd,
        printagentCd: printagentCd,
        printnumNr: printnumNr,
        parameter1Tx: parameter1Tx,
        updprogramCd: updprogramCd,
        selectIds: selectIds
      };
    }
    return this.http.post(url, jsonInput);
  }

  //印刷キューチェック
  checkPrintQueue(
    printagentCd: string,
    targetReportCdList: string[],
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSprUrl}/checkqueue`;
    const jsonInput = {
      printagentCd: printagentCd,
      targetList: targetReportCdList,
      updprogramCd: updprogramCd
    };
    return this.http.put(url, jsonInput);
  }  
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/client-report/client-report.service.ts